import { t } from "i18next";
import moment from "moment";
import { mutate } from "swr";

export async function publishProjectStatus(
    data: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/project/public`;
    try {
        const result = await fetchGlobal<any>(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        return result;
    } catch (error) {
        console.error("Error publishing project status:", error);
    }
}

async function prepareDissociationData(
    project: any,
    rowData: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any
) {
    const keys: string[] = [];
    const associatesKeys: string[] = [];
    const associateShops: string[] = [];

    for (const subEl of project.subRows) {
        for (const item of rowData.subRows) {
            if (
                subEl?.id_boutique === item?.id_boutique &&
                project?.Status === "Publié"
            ) {
                associatesKeys.push(item.id_boutique);
                keys.push(item.id_boutique);
                associateShops.push(...project.shopKey);
            }
        }
    }

    const dedupedKeys = [...new Set(associatesKeys)];
    const dedupedShops = [...new Set(associateShops)];
    const shouldArchive = project.subRows.length === dedupedKeys.length;

    const savedData = {
        userId: userID,
        franchiseId: franchiseID,
        project_id: "PROJECT",
        projectId: project.projectId,
        operatorId: operatorID,
        uuidUser: uuidUser,
        shopId: "0",
        shopsKey: dedupedKeys.join(","),
    };

    return {
        keys: dedupedKeys,
        associateShops: dedupedShops,
        shouldArchive,
        savedData,
    };
}
export async function dissociation(
    projectData: any[],
    rowData: any,
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
): Promise<{ allKeys: string[]; projectsToArchive: any[] }> {
    const allKeys: string[] = [];
    const projectsToArchive: any[] = [];
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/projects/dissociation/shops`;

    for (const project of projectData) {
        const {
            keys,
            shouldArchive,
            savedData,
        } = await prepareDissociationData(
            project,
            rowData,
            userID,
            franchiseID,
            operatorID,
            uuidUser
        );

        allKeys.push(...keys);
        if (shouldArchive) {
            projectsToArchive.push(project);
        }
        if (keys.length > 0) {
            try {
                const data = await fetchGlobal<any>(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(savedData),
                });

                if (data.error) {
                    throw new Error("Error while saving dissociation data");
                }
            } catch (error) {
                console.error(`${t("There's an error")}!`, error);
            }
        }
    }

    return {
        allKeys: [...new Set(allKeys)],
        projectsToArchive,
    };
}

const getProjectData = async (
    element: any,
    oneShop: any,
    shopID: any,
    franchiseID: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) => {
    let dataProject = {};
    let apiUrl = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/projectData?userId=106&shopId=${
        oneShop ? shopID : element?.shopId
    }&franchiseId=${franchiseID}&projectId=${
        element?.id_project ?? element?.projectId
    }`;
    try {
        const data = await fetchGlobal<any>(apiUrl, {
            headers: {
                "Content-Type": "application/json",
            },
            method: "GET",
        });
        mutate(apiUrl, data);
        dataProject = data[0];

        return dataProject;
    } catch (e: any) {}
};

export async function archiveProjects(
    projects: any[],
    userID: any,
    franchiseID: any,
    operatorID: any,
    uuidUser: any,
    oneShop: any,
    shopID: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiProject = `${process.env.REACT_APP_API_V2_URL}/settings/project`;
    let hasError = false;
    for (const project of projects) {
        const dataProject: any = await getProjectData(
            project,
            oneShop,
            shopID,
            franchiseID,
            fetchGlobal
        );
        const savedDataProject = {
            userId: userID,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            shopId: "0",
            data: {
                PROJECT: {
                    id_project: "PROJECT",
                    data_project: {
                        [project.projectId]: {
                            projectId: project.projectId,
                            designation: project[t("Designation")],
                            associates: {},
                            isArchived: true,
                            template: dataProject.template,
                            files: dataProject.files,
                            note: project[t("Remark")],
                            nombre: project.Nombre,
                            status: "en attente",
                            modified_at: moment().format(
                                "DD/MM/YYYY [at] h:mm a"
                            ),
                            hour: moment().format("DD/MM/YYYY [at] h:mm a"),
                        },
                    },
                },
            },
        };
        let localHasError = false;
        try {
            const data = await fetchGlobal<any>(apiProject, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(savedDataProject),
            });
            mutate(apiProject, data);
            if (data.error) {
                localHasError = true;
                throw new Error("Error while archiving project!");
            }
        } catch (error) {
            localHasError = true;
            console.error(`${t("There's an error")}!`, error);
        }
        hasError = localHasError;
    }
    return hasError;
}

export async function RedisPublishList(
    ids: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/overwite/redisList`;
    try {
        const data = await fetchGlobal<any>(apiUrl, {
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                shopId: ids,
            }),
            method: "POST",
        });
        mutate(apiUrl, data);
        if (data.error) {
            throw new Error("Error while archiving project!");
        }
    } catch (e: any) {
        console.log(`${t("There's an error")}!`);
    }
}

export async function addHistory(
    data: any,
    franchiseId: string,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/history?franchiseId=${franchiseId}`;
    try {
        const result = await fetchGlobal<any>(apiUrl, {
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data,
            }),
            method: "POST",
        });
        mutate(apiUrl, data);
        if (result.error) {
            throw new Error("Error while archiving project!");
        }
    } catch (e: any) {
        console.log(`${t("There's an error")}!`);
    }
}
